import { currencyList } from "./currencyList"

const defaultCurrency = () => {
  return Object.keys(currencyList)
}

export default defaultCurrency
